export const CONTACT_EMAIL = 'hello@slotgids.co.nz';

export const contactTopics = [
  {
    title: 'Samenwerking & partnerships',
    description: 'Voor casino’s, providers en affiliatepartners die willen samenwerken met SlotGids.',
    subject: 'Samenwerking met SlotGids',
  },
  {
    title: 'Fout of correctie melden',
    description: 'Klopt een RTP, maximale winst of andere informatie niet? Laat het ons weten, we passen het snel aan.',
    subject: 'Correctie op SlotGids',
  },
  {
    title: 'Vraag over een slot',
    description: 'Twijfel je over een slot uit de Top 30 of mis je een game in onze ranglijst?',
    subject: 'Vraag over een slot',
  },
  {
    title: 'Pers & media',
    description: 'Voor journalisten en media die informatie of commentaar zoeken over online slots in Nieuw-Zeeland.',
    subject: 'Persvraag SlotGids',
  },
];
